export const content = `BetterHelp accepts the following forms of payment:

- Credit cards
- Health Savings Accounts (HSA) via card
- Flexible Spending Accounts (FSA) via card
- Payment via your insurance or health plan
`;
